export default "__VITE_ASSET__Oy31mtU2__"